import { MDBCarousel, MDBCarouselCaption, MDBCarouselItem, MDBRow } from "mdb-react-ui-kit";
import './FlapPicture.css'
// import React from "react";

interface flap_picture {

    img: string
    caption: string

}
const flap_picture_list: Array<flap_picture> = [
    {
        img: '../../flap_pics/flap_pic_1.jpeg',
        caption: 'The MoFA director in charge of Horticulture advising students in Agro-Biodiversity Fun Club at Mangoase Senior High School '
    },
    {
        img: '../../flap_pics/flap_pic_2.jpeg',
        caption: 'Visit to the Mangoase Community seed bank'
    },
    {
        img: '../../flap_pics/flap_pic_3.jpeg',
        caption: 'NUS Network Ghana Consultation Meeting on Development of the National Action Agenda for Neglected and Underutilized Species'
    },
    {
        img: '../../flap_pics/flap_pic_4.jpeg',
        caption: 'Much love from members of the school Agro-biodiversity fun club'
    },

    {
        img: '../../flap_pics/chrismas_wish.jpeg',
        caption: ''
    }
]

export function FlapPicture() {

    return (
        <>
            <MDBCarousel className={'border border-0 border-success px-0'} showIndicators showControls fade>
                {flap_picture_list.map(
                    (flap_pic, index) => (
                        <MDBCarouselItem key={index} className={'border border-0 border-danger'} itemId={index + 1}>
                            <img src={flap_pic.img} className='d-block w-100' alt={`flap image ${index + 1}`} />
                            {flap_pic.caption !== '' ? 
                            <MDBCarouselCaption className={'caption border border-0 border-danger d-sm-flex opacity-75'}>
                                <h3>{flap_pic.caption}</h3>
                            </MDBCarouselCaption>
                            : ''}
                        </MDBCarouselItem>
                    )
                )}
            </MDBCarousel>
        </>
    )
}